import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import {
  ArchiveFill,
  ArrowClockwise,
  PenFill,
  PersonPlusFill,
  ThreeDots,
} from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import useDash from "../../../assets/css/dash.module.css";
import { FontColor, FourGround } from "../../../assets/js/theme";
import Loader from "../../../components/common/Loader";
import Table from "../../../components/table/Table";
import Footer from "../../../components/admin/footer/Footer";
import SupportNUmberDialog from "./SupportNUmberDialog";
import {
  deleteResellerSupportNumber,
  getResellerSupportNumber,
} from "../../../features/apiCallReseller";
import useISPowner from "../../../hooks/useISPOwner";

const SupportNumber = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //---> Get user & current user data form useISPOwner hooks
  const { userData } = useISPowner();

  //---> @Get reseller support numbers from redux store
  const supportNumbers = useSelector((state) => state.reseller?.supportNumber);

  //---> Local Statesz
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalState, setModalState] = useState("");
  const [show, setShow] = useState(false);
  const [supportNumber, setSupportNumber] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    !supportNumbers?.length &&
      getResellerSupportNumber(dispatch, userData?.id, setIsLoading);
  }, []);

  const reloadHandler = () => {
    getResellerSupportNumber(dispatch, userData?.id, setIsLoading);
  };

  const handleSupportNumberDeleted = (supportId) => {
    let confirm = window.confirm(t("antToDeleteSupport"));
    if (confirm) {
      deleteResellerSupportNumber(
        dispatch,
        userData?.id,
        supportId,
        setLoading,
      );
    }
  };

  const columns = useMemo(
    () => [
      {
        width: "16%",
        Header: "#",
        id: "row",
        accessor: (row) => Number(row.id + 1),
        Cell: ({ row }) => <strong>{Number(row.id) + 1}</strong>,
      },
      {
        Header: t("name"),
        width: "16%",
        accessor: "name",
      },
      {
        Header: t("mobile"),
        width: "20%",
        accessor: "mobile",
      },
      {
        width: "16%",
        Header: t("startTime"),
        accessor: "start",
        Cell: ({ cell: { value } }) => moment(value).format("LT"),
      },
      {
        width: "16%",
        Header: t("endTime"),
        accessor: "end",
        Cell: ({ cell: { value } }) => moment(value).format("LT"),
      },

      {
        width: "16%",
        Header: () => <div className="text-center">{t("action")}</div>,
        id: "option",
        Cell: ({ row: { original } }) => (
          <div className="d-flex align-items-center justify-content-center">
            <div className="dropdown">
              <ThreeDots
                className="dropdown-toggle ActionDots"
                id="areaDropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu" aria-labelledby="customerDrop">
                <li
                  data-bs-toggle="modal"
                  data-bs-target="#supportEdit"
                  onClick={() => {
                    setModalState("supportNumber");
                    setShow(true);
                    setIsUpdate(true);
                    setSupportNumber(original);
                  }}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <PenFill />
                      <p className="actionP">{t("edit")}</p>
                    </div>
                  </div>
                </li>

                <li
                  data-bs-toggle="modal"
                  data-bs-target="#supportDelete"
                  onClick={() => handleSupportNumberDeleted(original.id)}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <ArchiveFill />
                      <p className="actionP">{t("delete")}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        ),
      },
    ],
    [t],
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div>{t("supportNumbers")}</div>
                  <div className="d-flex align-items-center justify-content-center">
                    <PersonPlusFill
                      className="addcutmButton"
                      title={t("addSupportTicket")}
                      onClick={() => {
                        setModalState("supportNumber");
                        setShow(true);
                        setIsUpdate(false);
                      }}
                    />

                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          onClick={() => reloadHandler()}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </FourGround>
              <FourGround>
                <div className="collectorWrapper mt-2 py-2">
                  <Table
                    isLoading={isLoading}
                    columns={columns}
                    data={supportNumbers}
                  />
                </div>
              </FourGround>

              <Footer />
            </FontColor>
          </div>
        </div>
      </div>

      {/* Customer support number dialog */}
      {modalState === "supportNumber" && (
        <SupportNUmberDialog {...{ show, setShow, isUpdate, supportNumber }} />
      )}
    </>
  );
};

export default SupportNumber;
